/**
 * Prevent duplicate form submissions for product cards
 * This script ensures that add-to-cart forms are only submitted once
 */
(function() {
  'use strict';
  
  // Prevent multiple executions of this script
  if (window.__preventDuplicateSubmissionsLoaded) {
    return;
  }
  window.__preventDuplicateSubmissionsLoaded = true;
  
  const submittingForms = new WeakMap();
  const processingButtons = new WeakSet();
  
  // Disable button on click (first line of defense)
  document.addEventListener('click', function(e) {
    const button = e.target.closest('button[type="submit"]');
    if (!button) return;
    
    const form = button.closest('form');
    if (!form || !form.id || typeof form.id !== 'string' || !form.id.startsWith('CollectionAddToCartForm-')) {
      return;
    }
    
    // If button is already processing, prevent click
    if (processingButtons.has(button)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
    
    // Mark button as processing
    processingButtons.add(button);
    button.disabled = true;
    
    // Re-enable after 4 seconds (backup)
    setTimeout(function() {
      processingButtons.delete(button);
      button.disabled = false;
    }, 4000);
    
  }, true); // Use capture
  
  // Prevent duplicate form submissions (second line of defense)
  document.addEventListener('submit', function(e) {
    const form = e.target;
    
    // Only handle product card forms
    if (!form.id || typeof form.id !== 'string' || !form.id.startsWith('CollectionAddToCartForm-')) {
      return;
    }
    
    // Check if form is already marked as submitting
    if (form.dataset.submitting === 'true') {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
    
    const now = Date.now();
    const lastSubmit = submittingForms.get(form);
    
    // If this form was submitted less than 2 seconds ago, prevent duplicate
    if (lastSubmit && (now - lastSubmit) < 2000) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
    
    // Mark this form as submitted (multiple ways)
    form.dataset.submitting = 'true';
    submittingForms.set(form, now);
    
    // Clear the flag after processing
    setTimeout(function() {
      form.dataset.submitting = 'false';
    }, 2000);
    
  }, true); // Use capture phase to intercept before other listeners
  
  // Intercept fetch requests to cart/add (third line of defense)
  const originalFetch = window.fetch;
  const pendingRequests = new Map();
  
  window.fetch = function(url, options) {
    // Only intercept cart add requests
    if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('cart_add_url'))) {
      const requestKey = JSON.stringify({ url, body: options?.body });
      const now = Date.now();
      const lastRequest = pendingRequests.get(requestKey);
      
      // If same request was made less than 1 second ago, block it silently
      if (lastRequest && (now - lastRequest) < 1000) {
        // Return a resolved promise with empty response to avoid console errors
        return Promise.resolve(new Response('{}', { 
          status: 200, 
          headers: { 'Content-Type': 'application/json' }
        }));
      }
      
      pendingRequests.set(requestKey, now);
      
      // Clean up old entries after 2 seconds
      setTimeout(() => {
        pendingRequests.delete(requestKey);
      }, 2000);
    }
    
    return originalFetch.apply(this, arguments);
  };
  
})();
